mutation OverwriteEditablesWithCampaignScope(
    $overwrites: [InputOverwriteEditableWithCampaignScope]!
    $campaignId: ID!
) {
    overwriteEditablesWithCampaignScope(campaignId: $campaignId, overwrites: $overwrites) {
        _id
    }
}
